import {
  fetchDeleteUserReplyTemplate,
  type TDeleteUserReplyTemplateResponse,
  type TDeleteUserReplyTemplateRequest,
} from '../../repositories/chats/v1/delete-user-reply-template';
import { EExceptionDomain } from '../../types/exceptionDomains';
import { getGenericLikeError } from '../../utils/logging/getGenericLikeError';
import { getResponseError } from '../../utils/logging/getResponseError';

import type { IApplicationContext } from '../../types/applicationContext';
import type { FetchResponse } from '@cian/http-api';

const DEFAULT_ERROR_MESSAGE = 'Ошибка удаления шаблона ответа';

export async function deleteUserReplyTemplatePublic(
  context: IApplicationContext,
  parameters: TDeleteUserReplyTemplateRequest,
) {
  const { httpApi, logger } = context;

  try {
    const { response, statusCode }: FetchResponse<TDeleteUserReplyTemplateResponse> =
      await fetchDeleteUserReplyTemplate({
        httpApi,
        parameters,
      });

    if (statusCode !== 200) {
      throw getResponseError({
        domain: EExceptionDomain.ReplyTemplates,
        response,
        defaultMessage: DEFAULT_ERROR_MESSAGE,
        statusCode,
      });
    }

    return response;
  } catch (e) {
    const exception = getGenericLikeError({
      error: e,
      domain: EExceptionDomain.ReplyTemplates,
      message: DEFAULT_ERROR_MESSAGE,
    });

    logger.error(exception, {
      microserviceName: 'chats',
      pathApi: '/v1/delete-user-reply-template/',
      parameters: JSON.stringify(parameters),
    });

    throw exception;
  }
}
